<div [class]="status()" class="bar-melding">
    <div class="bar-melding__title">
        <h2 class="h4 mt-0 pt-0"><i [class]="['icon', iconClass()]"></i>{{ title() }}</h2>
    </div>
    <div class="bar-melding__content" [innerHTML]="sanitizedMeldingContent()"></div>
</div>
